import React from 'react';
import { getMentoringPageContent } from '../mentoringContent';
import {
  ActionLink,
  Card,
  CardGrid,
  Facts,
  Figure,
  FigureRow,
  Hero,
  Section,
  Steps,
  TagList,
} from '../components/MentoringPrimitives';
import { MentoringPageShell } from './shared';

const AboutBody = ({ locale }) => {
  const content = getMentoringPageContent(locale, 'about');

  if (!content) {
    return null;
  }

  const { hero, where, operation, ecosystem, history, team, vision } = content;

  return (
    <>
      <Hero {...hero} split />

      <Section
        marker={where.marker}
        eyebrow={where.eyebrow}
        title={where.title}
        lead={where.lead}
      >
        <div className="mt-split mt-split--2">
          <div>
            <Facts items={where.facts} stacked />
          </div>
          <Figure label={where.figure.label} />
        </div>
      </Section>

      <Section
        marker={operation.marker}
        eyebrow={operation.eyebrow}
        title={operation.title}
        tone="paper2"
      >
        <CardGrid cols={2}>
          {operation.items.map((item) => (
            <Card key={item.number} tag={item.number} title={item.title} text={item.text} />
          ))}
        </CardGrid>

        <div className="mt-rhythm">
          <p className="mt-subhead">{operation.rhythmTitle}</p>
          <p className="mt-lead mt-rhythm-lead">{operation.rhythmLead}</p>
          <TagList items={operation.rhythm} />
        </div>
      </Section>

      <Section
        marker={ecosystem.marker}
        eyebrow={ecosystem.eyebrow}
        title={ecosystem.title}
        lead={ecosystem.lead}
      >
        <CardGrid cols={3}>
          {ecosystem.entries.map((entry) => (
            <Card
              key={entry.title}
              title={entry.title}
              text={entry.text}
              state={entry.state}
            />
          ))}
        </CardGrid>
      </Section>

      <Section
        marker={history.marker}
        eyebrow={history.eyebrow}
        title={history.title}
        lead={history.lead}
        tone="ink"
      >
        <Steps items={history.items} />
      </Section>

      <Section
        marker={team.marker}
        eyebrow={team.eyebrow}
        title={team.title}
        lead={team.lead}
      >
        <FigureRow figures={team.figures} />
        <div className="mt-section__actions">
          <p className="mt-note">{team.note}</p>
        </div>
        <div className="mt-section__actions">
          <ActionLink action={team.cta} />
        </div>
      </Section>

      <Section
        marker={vision.marker}
        eyebrow={vision.eyebrow}
        kicker={vision.kicker}
        title={vision.title}
        lead={vision.lead}
        tone="accent"
      >
        <CardGrid cols={3}>
          {vision.features.map((feature) => (
            <Card key={feature.title} title={feature.title} text={feature.text} />
          ))}
        </CardGrid>
        <div className="mt-section__actions">
          <p className="mt-note">{vision.note}</p>
        </div>
        <div className="mt-section__actions">
          <ActionLink action={vision.cta} variant="on-dark" />
        </div>
      </Section>
    </>
  );
};

export default function MentoringAboutPage({ locale }) {
  return (
    <MentoringPageShell locale={locale} pageKey="about">
      <AboutBody locale={locale} />
    </MentoringPageShell>
  );
}
